module.exports = __webpack_public_path__ + "img/4d2de24.jpg";